import React from 'react';
import { CnEntryPoints as CnEntryPointsView } from './entry-points-view';
class CnEntryPoints extends React.Component {
    constructor(props) {
        super();
        this.ref = React.createRef();
    }
    render() {
        return React.createElement(CnEntryPointsView, { ref: this.ref, ...this.props });
    }
}
CnEntryPoints.displayName = 'CnEntryPoints';
export default CnEntryPoints;
export { CnEntryPoints };
